import React from 'react';

/**
 * Table skeleton — reserves space so content loading doesn't cause
 * layout shift. Height matches the eventual rendered rows.
 */
export default function TableSkeleton({ rows = 6, cols = 6 }) {
  return (
    <div className="animate-pulse" data-testid="table-skeleton">
      <div className="h-9 bg-slate-100 border-b border-slate-200" />
      {[...Array(rows)].map((_, r) => (
        <div key={r} className="flex gap-3 px-4 py-3 border-b border-slate-100">
          {[...Array(cols)].map((__, c) => (
            <div key={c} className="h-4 bg-slate-100 rounded flex-1" />
          ))}
        </div>
      ))}
    </div>
  );
}
